import { render, staticRenderFns } from "./SelectProblemtyp.vue?vue&type=template&id=352fd9a0"
import script from "./SelectProblemtyp.vue?vue&type=script&lang=js"
export * from "./SelectProblemtyp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports